// @ts-nocheck
import { Block, Carousel } from '@xprog/prensa'
import { PageBlockTypes as p } from '@xprog/prensa/types'
import chunk from 'lodash/chunk'
import map from 'lodash/map'

import { teasers as T } from '../teasers'

const renderSlotWrapComponent = (data) => {
  const groupItems = chunk(data, 3)
  return (
    <Carousel
      axis='horizontal'
      css={{
        carousel: {
          width: '100%'
        },
        container: {
          width: '100%'
        },
        root: {
          width: '100%',
        },
        controlDots: {
          mt: '$2',
          mb: '$0',
        },
        controlDotsDot: {
          background: '#c4c4c4',
          boxShadow: 'none',
          height: '8px',
          width: '8px',
          opacity: '1',
          '&.selected': { background: 'black' }
        }
      }}
      labels={{
        item: '',
        leftArrow: 'Retroceder',
        rightArrow: 'Avançar'
      }}
      showArrows={false}
    >
      {map(groupItems, (items, key) => (
        <Block
          css={{ align: ['column', 'left', 'top'], width: 'auto' }}
          key={key}
        >
          {map(items, (item, key) => {
            return (
              <Block
                css={{ align: ['row', 'center', 'top'], width: 'auto' }}
                key={key}
              >
                {item}
              </Block>
            )
          })}
        </Block>
      ))}
    </Carousel>
  )
}
export const LayoutColumnistSideBox: p.SlotConfigProps = {
  wrapperContent: {
    enabled: true,
    component: renderSlotWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnContent': {
        pt: '$6',
        pb: '$6',
        maxWidth: 'calc(100% - $2)'
      },
    }
  },
  slotConfig: {
    TemplateSideBoxColumnist: {
      slotLeft: {
        default: [T.TeaserColumnist, T.TeaserColumnist]
      }
    }
  }
}